import { NewOrderTypes } from '../../../common/enums/enums';
import NewOrder from '../newOrder';

export const NewServiceOrder = () => {
  return <NewOrder orderType={NewOrderTypes.SERVICE_ORDER} />;
};
